var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AfterViewInit, ElementRef, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { bindFunctionsToThis, isNullOrUndefined } from '../../extensions';
import { BaseComponent } from '../base.component';
var MatFieldComponent = /** @class */ (function (_super) {
    __extends(MatFieldComponent, _super);
    function MatFieldComponent() {
        var _this = _super.call(this) || this;
        _this.class = '';
        _this.decimalPlaces = 1;
        _this.isRequired = false;
        _this.onInputFocus = new EventEmitter();
        _this.onEnterPress = new EventEmitter();
        _this.onModelChange = new EventEmitter();
        bindFunctionsToThis(_this);
        return _this;
    }
    Object.defineProperty(MatFieldComponent.prototype, "inputType", {
        get: function () {
            switch (this.type) {
                case 'password':
                    return 'password';
                case 'text':
                case 'textArea':
                default:
                    return 'text';
            }
        },
        enumerable: true,
        configurable: true
    });
    MatFieldComponent.prototype.disable = function () {
        console.log('this is disabled!');
    };
    Object.defineProperty(MatFieldComponent.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (newValue) {
            if (newValue === this._value || (isNullOrUndefined(this._value) && isNullOrUndefined(newValue))) {
                return;
            }
            this.setValue(newValue);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MatFieldComponent.prototype, "isDirty", {
        get: function () {
            return this.isFocusedOnce && this.formControl && (this.formControl.dirty || this.formControl.touched);
        },
        enumerable: true,
        configurable: true
    });
    MatFieldComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.formControl) {
            var oldMarkAsPristine_1 = this.formControl.markAsPristine.bind(this.formControl);
            this.oldUpdateValueAndValidity = this.formControl.updateValueAndValidity
                .bind(this.formControl);
            this.formControl.markAsPristine = function (options) {
                oldMarkAsPristine_1(options);
                _this.errorMessage = '';
                if (_this.inputElement) {
                    _this.inputElement.nativeElement.setCustomValidity(_this.errorMessage);
                }
            };
            this.formControl.updateValueAndValidity = function (options) {
                if (options && options['displayErrorMessage']) {
                    _this.isFocusedOnce = true;
                    _this.formControl.markAsDirty();
                }
                _this.updateValidationState(options);
            };
        }
    };
    MatFieldComponent.prototype.ngAfterViewInit = function () {
        this.bindInputRestrictions();
    };
    MatFieldComponent.prototype.ngOnDestroy = function () {
        if (this.formControl) {
            this.formControl.updateValueAndValidity = this.oldUpdateValueAndValidity;
        }
        _super.prototype.ngOnDestroy.call(this);
    };
    MatFieldComponent.prototype.writeValue = function (obj) {
        this.value = obj;
    };
    MatFieldComponent.prototype.registerOnChange = function (fn) {
        this._notifyChange = fn;
    };
    MatFieldComponent.prototype.registerOnTouched = function (fn) {
    };
    MatFieldComponent.prototype.setValue = function (newValue) {
        switch (this.type) {
            case 'number':
                newValue = newValue && parseInt(newValue);
                this._value = newValue;
                break;
            case 'float':
                if (newValue && (newValue.toString() === ',' || newValue.toString() === '.')) {
                    newValue = '0' + newValue;
                }
                newValue = newValue && parseFloat(newValue.toString().replace(',', '.'));
                this._value = newValue && (newValue.toString().replace('.', ','));
                break;
            default:
                this._value = newValue;
        }
        if (this._notifyChange && this.formControl && this.formControl.value !== newValue) {
            this._notifyChange(newValue);
        }
        this.updateValidationState();
    };
    MatFieldComponent.prototype.onBlur = function () {
        this.isFocusedOnce = true;
    };
    MatFieldComponent.prototype.onClick = function ($event) {
        this.onInputFocus.emit($event);
    };
    MatFieldComponent.prototype.onKeyup = function ($event) {
        if ($event.key === 'Enter') {
            this.onEnterPress.emit($event);
        }
    };
    MatFieldComponent.prototype.focus = function () {
        this.inputElement.nativeElement.focus();
    };
    MatFieldComponent.prototype.modelChange = function () {
        this.onModelChange.emit();
    };
    MatFieldComponent.prototype.updateValidationState = function (options) {
        if (this.formControl && this.oldUpdateValueAndValidity) {
            // Use this hack way to update FormControl value immediately
            this.formControl['_value'] = this._value;
            this.oldUpdateValueAndValidity(options);
            if (this.inputElement) {
                this.errorMessage = '';
                this.inputElement.nativeElement.setCustomValidity(this.errorMessage);
            }
        }
    };
    MatFieldComponent.prototype.bindInputRestrictions = function () {
        var _this = this;
        Observable.fromEvent(this.inputElement.nativeElement, 'input').subscribe(function () {
            if (_this.maxLength && _this.inputElement.nativeElement.value.length > _this.maxLength) {
                var caretStart = _this.inputElement.nativeElement.selectionStart;
                _this.inputElement.nativeElement.value = _this.inputElement.nativeElement.value.substr(0, _this.maxLength);
                _this.inputElement.nativeElement.setSelectionRange(caretStart, caretStart);
                _this.value = _this.inputElement.nativeElement.value;
            }
        });
    };
    return MatFieldComponent;
}(BaseComponent));
export { MatFieldComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/mat.field/mat.field.component.ts.pre-build-optimizer.js